// extracted by mini-css-extract-plugin
module.exports = {"container":"container--pn0OA","spin":"spin--yUtey","sider":"sider--qsdFh","content":"content--THe5U"};